import React from 'react';
import { Grid, Paper, Typography } from '@material-ui/core';
import moment from 'moment';

export default function SentList({
  showSent,
  selectedEmail,
  mailData,
  setSelectedEmail,
}) {
  if (!showSent) return null;
  const formatDate = (timestamp) => {
    return moment(timestamp).format("ddd HH:mm");
  };
  return (
    <Grid item xs={12} sm={12} md={selectedEmail ? 3 : 10}>
      <Paper>
        <Typography variant="h6" style={{ backgroundColor: '#D3D3D3', paddingLeft: '6px' }}>
          Sent Items
        </Typography>
        {mailData?.data?.getStudySiteEmails.map((item, index) => (
          <div
            key={index}
            onClick={() => {
              setSelectedEmail(item);
              //  setShowNewMail(false);
            }}
            style={{
              padding: '8px',
              borderBottom: '2px solid #e0e0e0',
              cursor: 'pointer',
              backgroundColor: selectedEmail === item ? '#f0f0f0' : 'white'
            }}
          >
            <div style={{ display: 'flex' }}>
              <div>
                <Typography variant="body2" className="m-0" style={{ color: "#212121" /* very dark grey */, fontWeight: 500 }}>{item.fromUser.email}</Typography>
                <Typography variant="body2" className="m-0">{item.emailSubject}</Typography>
                <Typography
                  variant="body2"
                  className="m-0"
                  color="textSecondary"
                  style={{
                    flexGrow: 1,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: 'vertical',
                    wordBreak: "break-word"
                  }}
                >
                  {item.emailBody && (
                    <div
                      dangerouslySetInnerHTML={{ __html: item.emailBody }}
                    ></div>
                  )

                  }
                </Typography>
              </div>
              <div style={{ marginLeft: 'auto', alignSelf: 'flex-start' }}>
                <Typography variant="body2" className="m-0" noWrap>
                  {formatDate(item.timeStamp)}
                </Typography>
              </div>
            </div>
          </div>
        ))}
      </Paper>
    </Grid>
  );
}
